import { render } from "./AccountView.vue?vue&type=template&id=74e255d4&scoped=true&ts=true"
import script from "./AccountView.vue?vue&type=script&lang=ts"
export * from "./AccountView.vue?vue&type=script&lang=ts"

import "./AccountView.vue?vue&type=style&index=0&id=74e255d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e255d4"]])

export default __exports__